import React from 'react';

import { isMobileMedia } from 'utils/media';
import CartContainer from 'cart/containers/CartContainer';
import MenuContainer from 'menus/containers/MenuContainer';
import withGoogleLibraryLoaded from 'base/hoc/withGoogleLibraryLoaded';

/* THIS SHOULD ONLY FIRES ON DIRECT HIT TO /CART */
class CartRouteContainer extends React.Component {
  render() {
    if (isMobileMedia()) {
      return <CartContainer />;
    }
    return <MenuContainer shouldOpenCart />;
  }
}

export default withGoogleLibraryLoaded(CartRouteContainer);
